(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle upsell form submissions
  const upsellForms = document.querySelectorAll('.upsell-add-form');
  
  upsellForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const button = form.querySelector('.upsell-add-btn');
      const originalText = button.textContent;
      const productId = form.closest('.cart-upsell-item').dataset.productId;
      
      // Show loading state
      button.textContent = 'Adding...';
      button.disabled = true;
      button.className = 'upsell-add-btn loading';
      
      // Get form data
      const formData = new FormData(form);
      
      // Use fetch to add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams(formData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Success
        button.textContent = '✓ Added';
        button.className = 'upsell-add-btn success';
        
        // Update cart counter if it exists
        const cartCounters = document.querySelectorAll('.cart-counter, .enj-cartcount, .cart-count');
        cartCounters.forEach(counter => {
          const currentCount = parseInt(counter.textContent) || 0;
          counter.textContent = currentCount + 1;
        });
        
        // Show success message and redirect after delay
        setTimeout(() => {
          // Refresh the page to show updated cart
          window.location.reload();
        }, 1500);
      })
      .catch(error => {
        // Error
        console.error('Error:', error);
        button.textContent = 'Error';
        button.className = 'upsell-add-btn error';
        
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.className = 'upsell-add-btn';
        }, 2000);
      });
    });
  });
  
  // Initialize upsell functionality
  const upsellContainer = document.getElementById('cart-upsell-products');
  if (upsellContainer && upsellContainer.children.length === 0) {
    upsellContainer.innerHTML = '<p style="text-align: center; color: #666; padding: 20px;">No recommendations available</p>';
  }
});

  } catch(e) { console.error(e); }
})();
})();
